import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../environments/environment';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class SimulateInvestmentService {

  private domain: any;
  private endpoint: string = 'simulate-investment';
  private api_key: any;

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.domain = `${environment.API_BASE_URL}${environment.version}`;
    this.api_key = environment.API_KEY;
  }

  async SIMULATE_INVESTMENT(body: any): Promise<any> {
    if (isPlatformBrowser(this.platformId)) {
      const currentUrl = this.document.location.href;
      const hostname = this.document.location.hostname;
      const urlParams = new URLSearchParams(currentUrl.split('?')[1]);
      const requestUrl = new URL(this.domain + this.endpoint);

      let headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'x-api-key': this.api_key,
      });

      if (!environment.ACTIVE_RECAPTCHA) {
        headers = headers.set('x-key', this.getEncryptedKey());
      }

      if (urlParams.has('rtir') && urlParams.get('rtir') === environment.HAS_UUID_REMOVE_RTIR && environment.ENVIRONMENT_NAME === 'test') {
        requestUrl.searchParams.set('rtir', environment.HAS_UUID_REMOVE_RTIR);
      }

      return this.http
        .post(requestUrl.href, body, { observe: 'response', headers })
        .toPromise()
        .then(this.extractData)
        .catch(this.extractData);
    }
    return Promise.reject('Server Side Rendering');
  }

  private getEncryptedKey(): string {
    const key = environment.SECRET_KEY;
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split('T')[0];
    const dataToEncrypt = `${formattedDate}:${key}`;
    const encryptedKey = CryptoJS.HmacSHA256(dataToEncrypt, key).toString(CryptoJS.enc.Hex);
    return encryptedKey;
  }

  private extractData(res: any) {
    let body = res;
    return body;
  }
}
